import React, { Component } from "react";
import { Cell, Checkbox, Grid, SelectField } from "react-md";
import "./PerfomanceAnalytics.css";
import BarChart from "./charts/BarChart";
import LineChart from "../charts/LineChart";
import moment from "moment";
import Toggle from "react-toggle";
import DonutChart from "../charts/DonutChart";
import PracticeSetDialog from "../Dashboard/components/practiceSetDialog";
import { NotificationManager } from "react-notifications";
import RadialChart from "./charts/RadialChart";

export default class TopicAnalytics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categories: this.props.selectedTopic?.categoryAnalytic.map(cat => {
                return {
                    ...cat,
                    checked: false
                }
            }).sort((a, b) => a.accuracyIndex - b.accuracyIndex),
            selectedCat: null,
            selectedCategoryKey: null,
            categoryPerformanceData: [],
            showBarChart: false,
            showPracticeSetDialog: false,
            practiceCategoriesSelected: []
        };
        console.debug("this.state.categories---", this.state.categories)
    }


    componentDidUpdate(prevProps, prevState) {
        console.debug("prevProps", prevProps, this.props.selectedTopic)
        if (this.props.selectedTopic?.key !== prevProps.selectedTopic?.key) {
            let catKey = this.props.selectedTopic ? this.props.selectedTopic.categoryAnalytic[0].key : null
            let sortedCategories = this.props.selectedTopic?.categoryAnalytic.map(cat => {
                return {
                    ...cat,
                    checked: false
                }
            }).sort((a, b) => a.accuracyIndex - b.accuracyIndex)

            console.debug("sortedCategories", sortedCategories)

            this.setState({
                selectedCat: sortedCategories ? sortedCategories[0] : null,
                selectedCategoryKey: catKey,
                categories: sortedCategories,
                showBarChart: false
            })

            if (catKey) {
                console.debug("catKey", catKey)
                this.getCategoryPerformance(catKey)
            }

        }

    }

    handleCategorySelect = (value) => {
        console.debug("value", value)
        this.setState({
            selectedCategoryKey: value
        })
        this.getCategoryPerformance(value)
    }

    getCategoryPerformance(catKey) {

        let payload = {
            subjectID: this.props.selectedTopic.subjectID,
            topicID: this.props.selectedTopic.topicID,
            catKey: catKey
        }

        let responsePromise = this.props.apiService({
            method: "POST",
            url: "/getAccuracyAndTimeOverTimeByCategory",
            data: payload
        });

        responsePromise.then(res => {
            console.debug("res", res)
            if (res && res.data && res.data.data) {
                this.setState({
                    categoryPerformanceData: res.data.data
                })
            }
        })
    }

    handleCreatePracticeSet = () => {

        let catsSelected = []
        catsSelected = this.state.categories.filter(cat => cat.checked)


        this.setState({
            practiceCategoriesSelected: catsSelected
        })

        if (catsSelected.length === 0) {
            NotificationManager.error("Please select atleast one category to create a new practice set.", "ERROR", 3000);
            return
        }
        this.setState({
            showPracticeSetDialog: true
        })
    }

    handlePracticeCategorySelect = (cat, isChecked) => {
        console.debug("cat, isChecked", cat, isChecked)
        let newCats = this.state.categories.map(c => {
            if (c.key === cat.key) {
                c.checked = isChecked
            }
            return c
        })

        this.setState({
            categories: newCats,
        })
    }

    handleTakeQuizURL(assignment) {

        let quizType;
        if (assignment.quizType !== undefined && assignment.quizType !== null) {
            quizType = assignment.quizType
        } else {
            quizType = assignment.quiz_type
        }

        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${quizType}`
        this.props.handleRoute(url)
    }

    onCreatePracticeSet = (practiceSetName) => {
        let quizDetails = [];

        let quizCategoryMasertyCountMap = {}
        let quizCategoryIsRequiredMap = {}
        let quizCategoryPositionMap = {}

        this.state.categories.forEach((selCat, index) => {
            if (!selCat.checked) return
            console.debug("selCat", selCat)
            let catKey = selCat.key
            let subCatKey = `${selCat.key}_${selCat.subcategoryID}`
            quizDetails.push({
                "subject_id": selCat.subjectID,
                "topic_id": selCat.topicID,
                "category_id": selCat.categoryID,
                "subcategory_id": selCat.subcategoryID,
                "index": subCatKey,
                "order": index + 1,
                "question_count": 10, // TODO
                "subcategory_name": selCat.subCategoryName,
                "category_name": selCat.name,
                "randomize_questions": selCat.randomize_questions,
                "random_subcategory_order": 1,
                "subcategory_weight": 1,
                "non_graded": 0,
                "category_mastery_count": 3, // set 3 as a default mastery count | selCat.masteryCount,
                "category_is_required": 1,
                "category_at_last": 0,
                "category_at_begining": 0
            })
            quizCategoryMasertyCountMap[catKey] = 3, // set 3 as a default mastery count | selCat.masteryCount,
                quizCategoryIsRequiredMap[catKey] = 1
            quizCategoryPositionMap[catKey] = {
                "category_at_last": 0,
                "category_at_begining": 0,
            }
        })


        let quizCategoryMasertyCountMapStr = JSON.stringify(quizCategoryMasertyCountMap)
        let quizCategoryIsRequiredMapStr = JSON.stringify(quizCategoryIsRequiredMap)
        let quizCategoryPositionMapStr = JSON.stringify(quizCategoryPositionMap)

        const startDate = moment().subtract(1, 'days');
        const endDate = moment().add(30, 'days');

        let payload = {
            quiz_name: practiceSetName,
            start_date: startDate.format('DD/MM/YYYY'),
            start_time: "00:00",
            end_date: endDate.format('DD/MM/YYYY'),
            end_time: "23:59",
            quiz_type: 0,
            mastery_condition: 3,
            mastery_units: this.state.categories.filter(cat => cat.checked).length, // Total cats 
            maximum_attempted: 2,
            semester_id: 0,
            course_id: -1, // -1 or null
            section_Id: -1, // -1 or null
            quiz_details: quizDetails,
            quiz_id: 0,
            testTimerEnabled: 0,
            fullScoreIfAttempted: 0,
            fixedAbsoluteTimeEnabled: 0,
            randomize_categories: 1,
            sections_list: [],
            splash_screen: <p>{practiceSetName}</p>,
            alt_splash_screen: "",
            NoCQC: 1,
            lockoutN: 20,
            enableSurvey: false,
            category_number_of_questions: '{}',
            category_mastery_count: quizCategoryMasertyCountMapStr,
            category_nocqc: quizCategoryIsRequiredMapStr, // category_nocqc had key and value as quizCategoryIsRequiredMapStr
            random_subcategory_order: quizCategoryIsRequiredMapStr, // random_subcategory_order had key and value as quizCategoryIsRequiredMapStr
            category_is_required: quizCategoryIsRequiredMapStr,
            category_position: quizCategoryPositionMapStr,
            free_choice_count: 0,
            subsection_id: 0,
            enable_subsection: false,
            is_nongraded: 1,
            allow_practice: true
        }

        console.debug("payload", payload)

        let responsePromise = this.props.apiService({
            method: "post",
            url: "/addQuiz",
            data: payload,
        });

        responsePromise.then(res => {
            console.log("res", res)
            if (res && res.data && res.data.data) {

                this.setState({
                    showPracticeSetDialog: false,
                })

                let userConfirmed = confirm("Your practice set has been created. Do you want to take it now?");
                if (userConfirmed) {
                    this.handleTakeQuizURL(res.data.data);
                }
            }

        })

    }


    render() {
        if (this.props.selectedTopic === null) return <></>
        return (
            <div>
                {/* Practice Set Dialog */}
                <PracticeSetDialog
                    showDialog={this.state.showPracticeSetDialog}
                    selectedCategories={this.state.practiceCategoriesSelected}
                    handleCloseDialog={() => {
                        this.setState({
                            showPracticeSetDialog: false
                        })
                    }}
                    onCreatePracticeSet={this.onCreatePracticeSet}
                />

                <h2 className="text-center font-weight-bold text-secondary">
                    {this.props.selectedTopic?.name}
                </h2>
                <Grid className="ml-2">
                    <Cell size={12} tabletSize={12} className="rounded-lg">
                        <Grid>
                            <Cell size={8} tabletSize={12} className="px-3">
                                {/* <div className="d-flex justify-content-center align-items-center">
                                    <Toggle
                                        id="toggle_bar_chart"
                                        icons={false}
                                        className="mr-2"
                                        checked={this.state.showBarChart}
                                        onChange={() => {
                                            this.setState({
                                                showBarChart: !this.state.showBarChart
                                            })
                                        }}
                                    />
                                    <label htmlFor='toggle_bar_chart' className="mt-2">Show Bar Chart</label>
                                </div> */}
                                <div className="d-flex justify-content-center py-3">
                                    {/* {this.state.showBarChart ?
                                        <BarChart categories={this.state.categories} /> :
                                        <RadialChart width="400px" categories={this.props.selectedTopic?.categoryAnalytic} />
                                    } */}

                                    <RadialChart width="400px" />
                                </div>
                            </Cell>
                            <Cell size={4} tabletSize={12}>
                                <div className="text-secondary fontClass-16 text-center mb-3 font-weight-bold">
                                    Cateogories Ranked by Accuracy Index Scores
                                </div>
                                <div>
                                    {this.props.selectedTopic?.categoryAnalytic?.map((cat, index) => {
                                        return (
                                            <div
                                                className="single-cat cursor-pointer my-1"
                                                key={index}
                                                style={{
                                                    background:
                                                        this.state.selectedCat?.name === cat.name
                                                            ? "#ededed"
                                                            : "",
                                                }}
                                            >
                                                <div className="d-flex justify-content-center align-items-center w-100">
                                                    <div>
                                                        <div
                                                            className="circle mr-2"
                                                            style={{
                                                                backgroundColor: cat.color,
                                                            }}
                                                        ></div>
                                                    </div>
                                                    <div
                                                        onClick={() => {
                                                            this.setState({
                                                                selectedCat: cat,
                                                            });
                                                        }}
                                                        className="px-2 w-100"
                                                    >
                                                        {cat.label ? cat.label : cat.name}
                                                    </div>
                                                </div>
                                                <div>
                                                    {/* <i className="fas fa-caret-up text-secondary"></i> */}
                                                    {/* Checkbox */}
                                                    <Checkbox id={index} checked={cat.checked} onChange={(val) => {
                                                        console.debug("val", val)
                                                        this.handlePracticeCategorySelect(cat, val)
                                                    }} />
                                                    {/* <input type="checkbox" /> */}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Cell>
                        </Grid>
                    </Cell>

                    <h3 className="text-center text-secondary w-100 mt-5 mb-3">
                        Performance by Category
                    </h3>

                    <div className="divider-line mb-4"></div>

                    <div className="w-100 d-flex flex-column justify-content-center align-items-center mb-4">
                        <label
                            htmlFor="select-categories"
                            className="fontClass-16 font-weight-bold"
                        >
                            Categories
                        </label>
                        <SelectField
                            id="select-categories"
                            // label={<div className="text-black fontClass-16 font-weight-bold float-none m-0">Categories</div>}
                            className="text-black px-2 pb-3"
                            sameWidth
                            floating={false}
                            style={{
                                minWidth: "200px",
                                backgroundColor: "#ebebeb",
                                borderRadius: "8px",
                            }}
                            value={this.state.selectedCategoryKey}
                            onChange={this.handleCategorySelect}
                            menuItems={this.props.selectedTopic?.categoryAnalytic?.map((cat) => {
                                return { ...cat, label: cat.label ? cat.label : cat.name, value: cat.key };
                            })}
                        />
                    </div>

                    <div className="w-100 d-flex justify-content-around align-items-center">
                        <Cell size={5} >
                            <div className="fontClass-18 text-center mb-2">Accuracy Index Over Time</div>
                            <div className="d-flex justify-content-center align-items-center mt-0">
                                <Toggle
                                    id="compare_with_classmates_accuracy"
                                    icons={false}
                                    className="mr-2"
                                    onChange={() => {

                                    }}
                                />
                                <label htmlFor='compare_with_classmates_accuracy' className="mt-2">compare with classmates</label>
                            </div>
                            <div>
                                {/* <LineChart /> */}
                                <LineChart
                                    // chartName={"Accuracy Index Over Time"}
                                    chartNameTooltip={"Accuracy Index Over Time"}
                                    labels={["", ...this.state.categoryPerformanceData?.map((cat, index) => {
                                        return `${cat.practiceCount + 1}`
                                    })]}
                                    values={this.state.categoryPerformanceData?.map(cat => {
                                        return { value: cat.accuracyIndex, color: 'white' }
                                    })}

                                    // labels={["", "09/01", "09/08", "09/15", "09/22", "09/29"]}
                                    // values={[
                                    //     { value: 20, color: "white" },
                                    //     { value: 34, color: "white" },
                                    //     { value: 54, color: "white" },
                                    //     { value: 76, color: "white" },
                                    //     { value: 91, color: "white" },
                                    // ]}
                                    pointBorderColor="#333"
                                    borderColor="#741A76"
                                    borderWidth={1.5}
                                    pointRadius={6}
                                    width="175px"
                                    height="105px"
                                />
                            </div>
                        </Cell>
                        <Cell size={5}>
                            <div className="fontClass-18 text-center mb-2">Time per Question Over Time</div>
                            <div className="d-flex justify-content-center align-items-center mt-0">
                                <Toggle
                                    id="compare_with_classmates_time"
                                    icons={false}
                                    className="mr-2"
                                    onChange={() => {

                                    }}
                                />
                                <label htmlFor='compare_with_classmates_time' className="mt-2">compare with classmates</label>
                            </div>
                            <div>
                                {/* <LineChart /> */}
                                <LineChart
                                    // chartName={"Time per Question Over Time"}
                                    chartNameTooltip={"Time per Question Over Time"}
                                    labels={["", ...this.state.categoryPerformanceData?.map((cat, index) => {
                                        return `${cat.practiceCount + 1}`
                                    })]}
                                    values={this.state.categoryPerformanceData?.map(cat => {
                                        return { value: cat.timeInSec, color: 'white' }
                                    })}
                                    // labels={["", "09/01", "09/08", "09/15", "09/22", "09/29"]}
                                    // values={[
                                    //     { value: 320, color: "white" },
                                    //     { value: 234, color: "white" },
                                    //     { value: 194, color: "white" },
                                    //     { value: 176, color: "white" },
                                    //     { value: 201, color: "white" },
                                    // ]}
                                    pointBorderColor="#333"
                                    borderColor="#741A76"
                                    borderWidth={1.5}
                                    pointRadius={6}
                                    width="175px"
                                    height="105px"
                                />
                            </div>
                        </Cell>
                    </div>
                    <div className="d-flex justify-content-center w-100 align-items-center mt-5">
                        <div className="btn2 d-flex justify-content-center align-items-center mr-5">
                            <Checkbox id="add_to_practice_set" label={<div className="fontClass-20">
                                Add to practice set
                            </div>} />
                        </div>
                        <div className="btn2">
                            Practice Again
                        </div>
                    </div>
                </Grid>
            </div>
        );
    }
}
